import  * as auth from './list/auth'
import  * as udesk from './list/udesk'
import  * as io from './list/io'


const actions = {
  auth,
  udesk,
  io,
}
export default actions